import { rem } from 'polished'
import { css } from 'styled-components'

import type { SearchTileDensity, SearchTileTreatment } from './searchTileDensity'

interface SearchTileDensityStyleProps {
  $density: SearchTileDensity
}

interface SearchTileTreatmentStyleProps {
  $treatment: SearchTileTreatment
}

export const searchTileContainerQueryUp = {
  tablet: `@container search-tile (width >= ${rem(578)})`,
  desktopSmall: `@container search-tile (width >= ${rem(670)})`,
  desktop: `@container search-tile (width >= ${rem(890)})`,
}

export const metaSearchTileContainerQueryUp = {
  ...searchTileContainerQueryUp,
  desktopLarge: `@container search-tile (width >= ${rem(1100)})`,
}

export function searchTileLayoutStyles(defaultMinHeight: string) {
  return css<SearchTileDensityStyleProps>`
    display: grid;
    min-height: ${props => props.$density === 'compact' ? rem(394) : defaultMinHeight};
    ${props => props.$density === 'compact' ?
      css`
        grid-template:
          "hero" ${rem(186)}
          "content" auto / 1fr;
      ` :
      css`
        grid-template:
          "hero" ${rem(172)}
          "content" auto / 1fr;
      `}

    ${searchTileContainerQueryUp.tablet} {
      min-height: ${props => props.$density === 'compact' ? rem(408) : defaultMinHeight};
      grid-template:
        "hero" ${rem(200)}
        "content" auto / 1fr;
    }

    ${searchTileContainerQueryUp.desktopSmall} {
      ${props => props.$density === 'compact' ?
        css`
          grid-template:
            "hero content" auto / ${rem(260)} minmax(0, 1fr);
        ` :
        css`
          grid-template: "hero content" auto / ${rem(300)} minmax(0, 1fr);
        `}
    }

    ${searchTileContainerQueryUp.desktop} {
      ${props => props.$density === 'compact' ?
        css`
          grid-template:
            "hero content" auto / ${rem(360)} minmax(0, 1fr);
        ` :
        css`
          grid-template: "hero content" auto / ${rem(410)} minmax(0, 1fr);
        `}
    }
  `
}

export const searchTileContentSpacingStyles = css<SearchTileDensityStyleProps>`
  gap: ${props => props.$density === 'compact' ? rem(12) : rem(16)};
  padding: ${props => props.$density === 'compact' ? rem(12) : rem(16)};

  ${searchTileContainerQueryUp.desktopSmall} {
    padding: ${props => props.$density === 'compact' ? rem(16) : rem(20)};
  }
`

export const searchTileFeaturedMatchBorderStyles = css<SearchTileTreatmentStyleProps>`
  ${props => props.$treatment === 'featured-match' && css`
    border-radius: ${props.theme.borderRadius.S};
    border: 2px solid ${props.theme.palette.highlight.primary.normalBackground};
    overflow: hidden;
  `}
`

export const searchTileResponsiveStateBorderStyles = css<SearchTileTreatmentStyleProps>`
  ${searchTileContainerQueryUp.tablet} {
    ${props => props.$treatment !== 'featured-match' && css`
      border-radius: ${props.theme.borderRadius.S};
      border: 1px solid ${props.theme.palette.neutral.surface.lightForeground};

      &.state-default {
        border: 1px solid ${props.theme.palette.neutral.surface.lightForeground};
      }
      &.state-highlighted {
        border: 1px solid ${props.theme.palette.highlight.primary.darkForeground};
      }
    `}

    ${searchTileFeaturedMatchBorderStyles}
  }
`
